"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// MIT © 2017 azu
var StoreGroup_1 = require("./StoreGroup");
var Dispatcher_1 = require("../Dispatcher");
/**
 * SingleStoreGroup is wrapper of a single Store.
 * It not aim to use in production.
 * It would be used in test or development.
 */
var SingleStoreGroup = /** @class */ (function (_super) {
    __extends(SingleStoreGroup, _super);
    function SingleStoreGroup(store) {
        var _this = _super.call(this) || this;
        _this.name = "SingleStoreGroup(" + store.name + ")";
        _this.storeGroup = new StoreGroup_1.StoreGroup({
            target: store
        });
        _this.pipe(_this.storeGroup);
        return _this;
    }
    SingleStoreGroup.prototype.onChange = function (handler) {
        return this.storeGroup.onChange(handler);
    };
    SingleStoreGroup.prototype.commit = function (commitment) {
        return this.storeGroup.commit(commitment);
    };
    SingleStoreGroup.prototype.useStrict = function () {
        return this.storeGroup.useStrict();
    };
    SingleStoreGroup.prototype.getState = function () {
        return this.storeGroup.getState().target;
    };
    SingleStoreGroup.prototype.emitChange = function () {
        return this.storeGroup.emitChange();
    };
    SingleStoreGroup.prototype.release = function () {
        return this.storeGroup.release();
    };
    return SingleStoreGroup;
}(Dispatcher_1.Dispatcher));
exports.SingleStoreGroup = SingleStoreGroup;
exports.createSingleStoreGroup = function (store) {
    return new SingleStoreGroup(store);
};
//# sourceMappingURL=SingleStoreGroup.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/UILayer/SingleStoreGroup.js
// module id = 483
// module chunks = 0